<script setup lang="ts">
import FadeTransition from '@/shared/components/transitions/FadeTransition.vue';
import { useNavigationBarStore } from './store.ts';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import LeaveFeedbackDot from '@/shared/components/core/LeaveFeedbackReminder/LeaveFeedbackDot.vue';
import { AppScreens } from '@/shared/types';

const { navList } = storeToRefs(useNavigationBarStore());

const zoomFix = ref(false);

onMounted(() => {
  // інакше не працює
  zoomFix.value = true;
});

</script>

<template>
  <FadeTransition visible>
    <div
      class="navigation-bar"
    >
      <div
        v-for="(navItem, index) in navList"
        v-show="navItem.visible"
        :key="index"
        class="nav-button"
        :class="{'active': navItem.active}"
        @click="navItem.action"
      >
        <Icon
          v-if="!navItem.active"
          :name="navItem.icon"
          :class="{'scale-instead-of-zoom': zoomFix}"
        />
        <Icon
          v-else
          :name="navItem.animatedIcon"
          class="animated-icon"
          :class="{'scale-instead-of-zoom': zoomFix}"
        />

        <div
          v-if="navItem.name === AppScreens.Menu"
          class="menu-alert-dot"
        >
          <LeaveFeedbackDot />
        </div>
      </div>
    </div>
  </FadeTransition>
</template>

<style scoped>
.navigation-bar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  pointer-events: all;

  background-color: rgba(0, 0, 0, 0.40);
  backdrop-filter: blur(12.5px);
  border-radius: 30px;
  padding-left: 10px;
  padding-right: 10px;
}

@media all and (min-width: 601px) {
  .navigation-bar {
    width: 100%;
  }
}

.nav-button {
  padding: 20px;
  border-radius: 50%;
  font-size: 20px;
  width: 22px;
  height: auto;
  max-width: 22px;
  max-height: 20px;
  color: #D8D4EF;
  z-index: 2;
  box-sizing: content-box;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.nav-button.active {
  font-size: 22px;
}

.animated-icon {
  height: 22px;
}

.menu-alert-dot {
  position: absolute;
  top: 22px;
  right: 14px;
  transform: translate(-50%, -50%);
  z-index: 10;
}
</style>
